import { SidebarLayout } from "@stoplight/elements-core";
import { Box, Flex, Heading, Icon} from "@stoplight/mosaic";
import { Link, useLocation } from "react-router-dom";
import { HIDE_QUERY_PARAM, LOCAL_STORAGE_ID, LOGO_HOST, LOGO_URL } from "../constants";
import { useMemo } from "react";

const isOnIFrame = window.location !== window.parent.location;
export default function NotFound() {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const hideParams = !isOnIFrame ? searchParams.get(HIDE_QUERY_PARAM)
    : searchParams.get(HIDE_QUERY_PARAM) || localStorage.getItem(LOCAL_STORAGE_ID);
  const hiddenParams = hideParams ? hideParams.split(',') : [];

  const sidebar = (
    <>
      {!hiddenParams.includes('logo') && <Box px={4} mb={4}>
        <img src={`${LOGO_HOST}${LOGO_URL}`} alt="Telflow" className="telflow-logo"/>
      </Box>}
      <Flex px={4} py={2}>
        <Link to="/"><Icon icon={['fas', 'arrow-left']}/> Home</Link>
      </Flex>
    </>
  );

  return (
    <SidebarLayout sidebar={sidebar} theme="invert">
      <Flex h='screen' flexDirection="col">
        <Box textAlign="center">
          <Box as={Icon} icon={['fas', 'exclamation-circle']} size="4x" color="light"/>
          <Heading size={2} mt={4} color="light">Page not found</Heading>
        </Box>
      </Flex>
    </SidebarLayout>
  );
}
